<template>
    <section>
        <div>
            <div>
                Jump to index
                <input v-model="index" placeholder="Index" type="number" style="color: black;">
            </div>
            <button type="button" @click="handleScrollTo">
                Go
            </button>
        </div>
        <div>
            <div>
                Filter list by size
                <input v-model="search" placeholder="e.g. small, medium, large" type="search" style="color: black;">
            </div>
        </div>
        <div v-bind="containerProps" style="height: 300px; overflow: auto;">
            <div v-bind="wrapperProps" class="wrapperGrid">
                <div v-for="{ index, data } in list" :key="index">
                    <!-- :style="{
                  height: `${data.height}px`,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }" -->
                    <div class="row">
                        Row {{ index }} <span style="opacity: 0.7;">({{ data.size }})</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { computed, ref } from 'vue'
import { useVirtualList } from '@vueuse/core'

export default {
    props: {
        allItems: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    setup(props) {
        const index = ref()
        const search = ref('')
        const filteredItems = computed(() => {
            return props.allItems.filter(i => i.size.startsWith(search.value.toLowerCase()))
        })
        const { list, containerProps, wrapperProps, scrollTo } = useVirtualList(
            filteredItems,
            {
                // itemHeight: i => (filteredItems.value[i].height + 8),
                itemHeight: 50,
                overscan: 10,
            },
        )
        const handleScrollTo = () => {
            scrollTo(index.value)
        }
        return {
            index,
            search,
            list,
            containerProps,
            wrapperProps,
            scrollTo,
            handleScrollTo,
        }
    },
}
</script>

<style scoped>
* {
    box-sizing: border-box;
}


div.wrapperGrid>div {
    background-color: #eee;
    border-radius: 4px;
    padding: 8px;
    border: 1px solid #ccc;
    height: 50px;
}
</style>